import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'membershipTouAcceptanceDialog.title',
    defaultMessage: 'Accept the Terms of Use',
  },
  acceptLabel: {
    id: 'membershipTouAcceptanceDialog.acceptLabel',
    defaultMessage: 'I have read and accept these Terms of Use',
  },
  cancel: {
    id: 'membershipTouAcceptanceDialog.cancel',
    defaultMessage: 'Later',
  },
  confirm: {
    id: 'membershipTouAcceptanceDialog.confirm',
    defaultMessage: 'Accept',
  },
  accepted: {
    id: 'membershipTouAcceptanceDialog.accepted',
    defaultMessage: 'Terms of Use accepted',
  },
});

export default messages;
